// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { IntlShape } from 'react-intl';
import { injectIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import type { FormProps } from 'redux-form';

import type { Dispatch } from 'state/types';
import { bindActionCreatorsForm } from 'util/safeDispatch';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import { sendDiagnosticData } from 'state/commands/adminPropertiesCommands';
import { getActivePanelId } from 'state/selectors';
import localizedStrings from 'util/localizedStrings';
import { DIAGNOSTIC_DATA_PANEL_ID } from 'util/constants';
import { actions as serverActions } from 'state/reducers/serverReducer';

const { setIsSendingDiagnosticData } = serverActions;
const ACCOUNT_NAME_ID = 'accountNameId';

function validate(data) {
  const errors = {};
  if (!data.accountName) {
    errors.accountName = 'Required';
  }
  return errors;
}

type Props = {
  activePanelId: ?string,
  hideDialogPanel: () => void,
  intl: IntlShape,
  sendDiagnosticData: typeof sendDiagnosticData,
  setIsSendingDiagnosticData: typeof setIsSendingDiagnosticData,
} & FormProps;

class DiagnosticDataDialog extends Component<Props> {
  isOkEnabled: Function;
  onClose: Function;
  submit: Function;

  constructor() {
    super();
    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.onClose = this.onClose.bind(this);
    this.submit = this.submit.bind(this);
  }

  isOkEnabled() {
    return this.props.valid && !this.props.pristine;
  }

  submit(values, dispatch, props) {
    const { accountName, contactName, techSupportTicketNum } = values;
    this.props.sendDiagnosticData(
      accountName,
      contactName,
      techSupportTicketNum
    );
    this.props.setIsSendingDiagnosticData(true);
  }

  onClose() {
    this.props.reset();
  }

  render() {
    const {
      handleSubmit,
      intl: { formatMessage },
    } = this.props;

    return (
      <DialogPanel
        panelId={DIAGNOSTIC_DATA_PANEL_ID}
        activePanelId={this.props.activePanelId}
        closeAfterSave
        contentStyle={{ width: 675, height: 320 }}
        customButtonText={formatMessage(
          localizedStrings.DIAGNOSTIC_DATA_SEND_REPORT_BUTTON
        )}
        dialogFocusId={ACCOUNT_NAME_ID}
        hideDialogPanel={this.props.hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        onClose={this.onClose}
        onSave={handleSubmit(this.submit)}
        panelTitle={formatMessage(localizedStrings.DIAGNOSTIC_DATA_TITLE)}
        showCancel
      >
        <form
          onSubmit={handleSubmit(this.submit)}
          className="diagnostic-data-form"
          data-test-name="diagnostic-data-form"
        >
          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label">
                {formatMessage(localizedStrings.DIAGNOSTIC_DATA_ACCOUNT_NAME)}
              </label>
            </div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <Field
                    name="accountName"
                    id={ACCOUNT_NAME_ID}
                    className="input"
                    component="input"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label">
                {formatMessage(localizedStrings.DIAGNOSTIC_DATA_CONTACT_NAME)}
              </label>
            </div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <Field
                    name="contactName"
                    className="input"
                    component="input"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label">
                {formatMessage(
                  localizedStrings.DIAGNOSTIC_DATA_TS_TICKET_NUMBER
                )}
              </label>
            </div>
            <div className="field-body">
              <div className="field">
                <div className="control">
                  <Field
                    name="techSupportTicketNum"
                    className="input"
                    component="input"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </DialogPanel>
    );
  }
}

let wrappedDialog = reduxForm({
  form: DIAGNOSTIC_DATA_PANEL_ID,
  validate: validate,
})(DiagnosticDataDialog);

wrappedDialog = injectIntl(wrappedDialog);

export default (wrappedDialog = connect(
  state => ({
    activePanelId: getActivePanelId(state),
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsForm({
      hideDialogPanel,
      sendDiagnosticData,
      setIsSendingDiagnosticData,
    })
)(wrappedDialog));



// WEBPACK FOOTER //
// ./src/view/App/DialogPanels/DiagnosticDataDialog.js